import { createSlice } from '@reduxjs/toolkit'

import { constraintsAdapter } from './constraintsAdapter'

export const initialConstraintState = constraintsAdapter.getInitialState()

export const constraintsSlice = createSlice({
  name: 'constraints',
  initialState: initialConstraintState,
  reducers: {
    upsertMultipleConstraints: (state, action) => {
      constraintsAdapter.upsertMany(state, action.payload)
    },
    replaceAllConstraints: (state, action) => {
      constraintsAdapter.setAll(state, action.payload)
    },
  },
})

export const { upsertMultipleConstraints, replaceAllConstraints } = constraintsSlice.actions